module.exports = __webpack_public_path__ + "img/save.78d478ad.svg";